module.exports = __webpack_public_path__ + "img/4bca8a6.svg";